import './form.scss';

import Checkbox from './Checkbox';
import { Input, Input2 } from './inputs';
import Radio from './Radio';
import Select from './Select';

export { Checkbox, Radio, Input, Input2, Select };
